<template>
    <content-comment-detail-link :detailLayout="detailLayout" :commentData="commentData"
                                 v-if="hasCommentData()"></content-comment-detail-link>
</template>

<script>
import contentUtil from "@/components/content/contentUtil";
import alertMixins from "@/mixins/alertMixins";
import contentValidator from "@/mixins/validators/contentValidator";
import ContentCommentDetailLink from "@/components/content/ContentCommentDetailLink";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

export default {
    name: "ContentCommentDetailComponent",
    mixins: [contentUtil, alertMixins, contentValidator],
    components: {ContentCommentDetailLink},
    provide() {
        return {
            commentDetailSetData: this.setData,
        }
    },
    inject: ['changeLoading'],
    props: {
        commentType: {default: ''},
        commentKey: {default: 0},
    },
    data() {
        return {
            detailLayout: '',
            getCategoryFunc: '',
            categoryApiParamsSet: {},
            getFunc: '',
            detailApiParamsSet: {},
            getDetailParamsKey: 'id',
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},

            commentData: {},
            updateFunc: '',


        }
    },
    created() {
        this.initFilterConfig();
        if (this.commentKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getComment();
        }

    },
    mounted() {
        EventBus.$on('writeComment', this.writeComment)
        EventBus.$on('deleteComment', this.deleteConfirm)
    },
    beforeDestroy() {
        EventBus.$off('writeComment')
        EventBus.$off('deleteComment')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig() {
            let config = this.returnContentConfig(this.commentType);
            this.detailLayout = config.detailLayout;
        },
        initFilterConfig() {
            let config = this.returnContentConfig(this.commentType);
            this.getFunc = config.getFunc;
            this.detailApiParamsSet = config.detailApiParamsSet;
            this.getDetailParamsKey = config.getDetailParamsKey;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.updateFunc = config.updateFunc;
            this.parsingData = config.parsingData;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.keyName = config.keyName;

        },
        getComment() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            params[this.getDetailParamsKey] = this.commentKey;
            this.$api.$content[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 || util.isEmpty(res.List)) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }

                this.commentData = res.List.Content[0];
                this.initTemplateConfig();
            })
        },
        hasCommentData() {
            if (this.commentKey !== 0) {
                return !util.isEmpty(this.commentData)
            } else
                return true
        },
        writeComment() {
            if (this.commentData.hasOwnProperty('Reply') && !util.isEmpty(this.commentData.Reply)) {
                this.updateComment()
            } else {
                this.createComment()
            }
        },
        createComment() {
            this.changeLoading(true);
            let params = this.writeApiParamSet
            params.c_idx = this.commentData.c_idx
            params.cc_parent = this.commentData.cc_idx
            let dataArr = Object.keys(this.parsingData);
            dataArr.forEach(dataKey => {
                params[this.parsingData[dataKey]] = this[dataKey];
            })
            try {
                this.$api.$content[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnCommentType(res.Info.type)
                    if (type != true) {
                        this.changeLoading(false);
                        this.errorAlert(type);
                    } else {
                        this.changeLoading(false);
                        this.createAlert({
                            content: '저장되었습니다.', hide: () => {
                                this.getComment()
                            }
                        })
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        updateComment() {
            this.changeLoading(true);
            let params = this.writeApiParamSet
            params.cc_idx = this.commentData.Reply.cc_idx
            let dataArr = Object.keys(this.parsingData);
            dataArr.forEach(dataKey => {
                params[this.parsingData[dataKey]] = this[dataKey];
            })
            try {
                this.$api.$content[this.updateFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnCommentType(res.Info.type)
                    if (type != true) {
                        this.changeLoading(false);
                        this.errorAlert(type);
                    } else {
                        this.changeLoading(false);
                        this.createAlert({
                            content: '저장되었습니다.', hide: () => {
                                this.getComment()
                            }
                        })
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        returnCommentType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패했습니다' : this.writeFailTypes[type]
            }
        },
        deleteConfirm() {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: () => {
                    this.deleteComment()
                },
            })
        },
        deleteComment() {
            this.changeLoading(true);
            let params = {cc_type:'reply',cc_idx : this.commentData.Reply.cc_idx }
            try {
                this.$api.$content.deleteContentComment(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type == 1 ){
                        this.changeLoading(false)
                        this.createAlert({
                            content:'삭제되었습니다.',
                            hide:()=>{
                                this.getComment();
                                EventBus.$emit('commentInitSet')
                            }
                        })
                    }else {
                        this.changeLoading(false)
                        this.errorAlert('삭제에 실패했습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        }


    },
    watch: {},
}
</script>

<style scoped>

</style>